// export const productionURL = "http://192.168.2.33:2504/v1";

export const productionURL = "https://api1.katbook.com/v1";